import"./MediaVideo.css.ts.vanilla.css";var x="xd50xx1",d="xd50xx0";export{x as mediaVideo,d as mediaVideoContainer};
